<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wU26RI/images/e9781439620984_cover.jpg?1688984943505" alt="This image is the cover for the book Evansville, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Evansville, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>The Evansville area was settled in 1839 and the village platted in 1855 on the hopes that the railroad would come through. It was named for Evansville�s first physician, Dr. John M. Evans. When the railroad arrived in 1863, Evansville�s prosperity was assured. There were many opportunities for growth in agriculture, manufacturing, and commerce. The Chicago and Northwestern Railroad offered passenger and freight service to major markets in Chicago and the West. Local farmers found national and international markets for their prizewinning livestock and produce. The Evansville Seminary and a strong public school system provided educational opportunities. Literary societies, churches, and veterans groups provided social activities. Talented 19th- and 20th-century architects and craftsmen were responsible for the fine collection of architectural styles in Evansville.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Ann Montgomery
      </h2>
      
      <p class="authorDescription body article">Photographs in Evansville come from the collections of the author, the Eager Free Public Library, the Rock County Historical Society, and longtime residents of Evansville. Ruth Ann Montgomery is a historian with an avid interest in preserving Evansville�s past. She has given talks, written articles, and digitized historic photographs and materials from the community.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0947b800